import React from 'react';

const TermsOfServiceEN = () => {
  return (
    <>
      <b>Article 1. Purpose</b>
      <br />
      The following Terms of Service apply to Mubeat (Hereinafter referred to as &quot;Service&quot;). The Service
      includes, but are not limited to, various websites, APIs, application and buttons, which are developed and
      arranged by Vlending Co, Ltd (Hereinafter referred to as &quot;Company&quot;).
      <br />
      The purpose of the Terms of Service is to clearly define the rights, obligations and responsibilities of the
      Company and the user (Hereinafter referred to as &quot;Member&quot;) of the Service. These Terms of Service affect
      your legal rights and obligations. By accessing, using, or registering the Service, you agree to be bound by these
      Terms. The terms include the provisions in this document, as well as those in the Privacy Policy.
      <br />
      If you have any questions, comments, or concerns regarding these Terms of Service or the Service, please contact
      us at support@mubeat.tv.
      <br />
      <br />
      <b>Article 2. Definitions</b>
      <br />
      The following words and terms shall have the meanings set forth below when they are used in the Terms of Service.
      <ol>
        <li>
          &quot;Service&quot; means the K-pop clip video service Mubeat, and various contents provided by the Company
          and its affiliates through smartphone device application to the Member.
        </li>
        <li>
          &quot;Member(s)&quot; means the user(s) who connects to the Service, agrees to the Company’s Terms of Service,
          and uses the Service.
        </li>
        <li>
          &quot;ID&quot; means the E-mail or the combination of letters from SNS unique code set by the Member and
          authorized by the Company for the purpose of identifying the Member and using the Service.
        </li>
        <li>
          &quot;Password&quot; means a combination of letters or numbers set by the Member himself/herself in order to
          protect confidentiality and to identify whether the Member matches with the given ID.
        </li>
        <li>
          &quot;Personal profile&quot; means ID and nickname used in the Service which is given for the purpose of user
          identification, and it includes the images of the profile picture set by the user.
        </li>
        <li>
          &quot;Postings(s)&quot; means the Member postings such as texts, graphics, data, articles, pictures, images,
          illustrations, videos, attached files and links uploaded by the Member by using the Service.
        </li>
        <li>
          &quot;Paid Membership&quot; means the Member paying separate cost and making a purchase, for example, monthly
          subscription for the Service and in-app purchases.
        </li>
        <li>
          &quot;Paid Service&quot; means one of the Company provided services that can be used by the Member paying a
          separate amount to the Company, or the Member agreeing the Company’s transaction or contract term to use.
        </li>
        <li>
          &quot;Beat(s)&quot; means the point(s) received by the Member through reimbursement, in exchange for
          promotions, events, other transaction agreements and fulfillment of conditions of the Company, or point(s)
          accumulated or purchased by the Member through watching advertisements, free charging stations and other
          services while using the Service.
        </li>
        <li>
          &quot;Fandom ad(s)&quot; means a service where a number of Members are able to celebrate the anniversaries of
          their favorite artists through fandom project(s).
        </li>
      </ol>
      <b>Article 3. Who May Use the Service</b>
      <br />A Member may use the Service only if they agree to form a binding contract with Vlending Co., Ltd and are
      not a person barred from receiving the Service under the laws of the applicable jurisdiction.
      <ol>
        <li>
          By accessing or using the Service in a country where the EU GDPR amendment is implemented, a Member confirms
          that he or she is at least 16 years old (or over the age of legal majority in your country, if higher) and is
          fully able and competent to comply with the Company’s Terms of Service. If the Member is under 16 or where
          applicable, he or she should not attempt to register for the Service or send any personal information to the
          Company. If the Company becomes aware that the Member is using the Service even though they are under 16 and
          are not permitted to do so, the Company will deactivate and delete the account.
        </li>
        <li>
          According to each country&apos;s law, it may lower the age limit for children requiring the consent of their
          legal representatives, such as parents, down till the age of 13. A Member under 16 or where applicable should
          only sign up after fully understanding the purpose of the collection and use of personal information and after
          obtaining the consent of a legal representative or parents. In addition, legal representatives, such as
          parents, may request to view, correct or renew the personal information of children, or withdraw their consent
          for membership, and in such cases, the Company shall take necessary measures without any delays.
        </li>
      </ol>
      If a parent believes that a child under the required minimum age may have provided the Company with their personal
      information, please contact the Company: support@mubeat.tv.
      <br />
      <br />
      <b>Article 4. Privacy</b>
      <br />
      The Company takes the privacy of the Member very seriously. The Privacy Policy describes how the Company handles
      the information the Members provide, when they use the Service. Members should understand that through their use
      of the Service, they consent to the collection and the use (as set forth in the Privacy Policy) of the information
      by the Company and its affiliates.
      <br />
      <br />
      <b>Article 5. Member’s Account</b>
      <br />
      To use some parts of the Service, a Member may need to create an account and provide certain information to the
      Company, including, but not limited to, E-mail address and password. The Member is responsible for safeguarding
      the created account, and use a strong password and limit its use to the account. The Company cannot and will not
      be liable for any loss or damage arising from the Member’s failure to comply with the above.
      <br />
      <br />
      <b>Article 6. Effect and Amendment of the Terms of Service</b>
      <ol>
        <li>
          The following Terms of Service will be in immediate effect when a user is registered as a Member and will
          terminate when the Member withdraws from the Service.
        </li>
        <li>
          The Terms of Service will be explicitly stated in Application &gt; Settings &gt; Terms of Service. The Company
          may update or revise these Terms from time to time and reserve the right to change the Terms at any time if a
          reasonable and necessary case occurs. Should the revisions be legally disadvantageous to the Member,
          notification of the changes shall be notified to the Member by electronic means, such as E-mails, other than
          just putting the public notice, starting from 30 days before the effective date.
        </li>
        <li>
          Modified Terms of Service will be posted in Application &gt; Settings &gt; Terms of Service and will be on
          immediate effect after 7 days.
        </li>
        <li>
          The most current version of the Terms will govern the relationship between the Company and the Member. By
          continuing to access or use the Services after those revisions become effective, the Member agrees to be bound
          by the revised Terms. Should the Member not agree to the amendment of the Terms of Service, he/she may choose
          to terminate the agreement for use of the Service.
        </li>
        <li>
          The Company will not be liable for disadvantage or loss incurred by being inattentive to the most up-to-date
          version of Terms of Service.
        </li>
        <li>
          If the Member using a paid service does not agree to the amendments to these terms and terminate the contract,
          refund policy will be followed from Article 12 (Paid Service Cancellation and Refund) in this Terms of
          Service.
        </li>
        <li>
          In cases where a Member signs up or logs in via services with Membership system linked to this Service, such
          as Facebook, Twitter, GMAIL, etc, the rights, obligations and responsibilities between the Member and the
          Company regarding personal information and membership system management are subject to the terms and
          conditions of the service in which the Member used to link to this Service.
        </li>
      </ol>
      These Terms are an agreement between the Member and Vlending Co., Ltd, a Korean company with its registered office
      11F, 343 Gangnam-daero, Seocho-gu, Seoul, 06626, Republic of Korea.
      <br />
      <br />
      <b>Article 7. Modification of the Contract details</b>
      <ol>
        <li>
          The Member can access and modify his/her personal information anytime through the personal information
          management page.
        </li>
        <li>
          The Member cannot change the ID registered when signing up. The ID that is once registered cannot be changed.
          But the Member can change the password through the Service application’s password modification or password
          modification guideline E-mail.
        </li>
        <li>
          The Company does not hold any liability but the Member will be liable for any disadvantages caused by the loss
          of registered personal information or registering false information.
        </li>
      </ol>
      <br />
      <b>Article 8. Posting Advertisement</b>
      <br />
      The Company may post its own or 3rd party’s advertisements in its Service.
      <br />
      <br />
      <b>Article 9. Paid Service Contract</b>
      <ol>
        <li>
          The Company provides both free and paid services. For separate paid service that the Company provides, the
          specified price must be paid to use the service.
        </li>
        <li>
          The Member must understand the Company’s described and noticed Terms of Service before entering into the
          contract and be able to transact accurately.
        </li>
        <li>
          The Member can use paid service provided by the Company through app store payment method. Paid service
          contract between the Company and the Member enters into agreement when (paid service’s procedural display
          “purchased/Transacted, etc.” has been shown) the Company’s has approved.
        </li>
        <li>
          The Company may decline or postpone acceptance for a certain period of time until the accomplishment of small
          condition or the reason of restriction has been resolved in one of the following cases.
          <ol>
            <li>
              If the subscription applicant has a history of losing the right as a Member in the past according to these
              terms
            </li>
            <li>If the Member used false name or stole someone else’s information</li>
            <li>If the Member provided false information or did not provide information requested by the Company</li>
            <li>
              If the Member with terminated contract due to not paying the service fee did not make the payment for
              arrears
            </li>
            <li>If the Member is apprehended to be violating social justice and moral</li>
            <li>If unable to retain maintenance or to offer service due to technical issue</li>
            <li>
              Unable to approve acceptance due to the Member’s fault or violation on various matters while requesting
              for acceptance
            </li>
          </ol>
        </li>
        <li>
          The Company may set transaction limit for the Member’s transaction payment in monthly accumulated payments,
          transaction limit under internal policy and external payment system provider’s regulations and if the Member
          desires to use paid service beyond the limit that the Company has set, additional paid service may be
          restricted due to limit excess of payment.
        </li>
      </ol>
      <b>Article 10. Paid Service Use</b>
      <ol>
        <li>
          Paid service begins when the Company has accepted (for partial services, designated date notified in advance
          after receiving use request) the Member’s request for paid membership and if paid membership cannot be
          initiated due to Company’s technical difficulties or other reasons, announcement will be notified to the
          Members by following Article 6 (Effect and Amendment of the Terms of Service).
        </li>
        <li>
          The Company notifies the Member about usage request when the Member’s request has been made. When the Member
          has accepted the Company’s gesture of discordance, correction or modification request must be made to the
          Company and the Company must follow the Member’s request. However, if the payment has already been made, the
          contract terminating regulation of this Terms of Service will be followed.
        </li>
        <li>
          The Company provides paid service like below and the service contents may be changed due to the Company’s
          circumstances or other various conditions.
          <ol>
            <li>
              Automatic Subscription: Monthly payment and service period automatically renewing with payment method that
              Member of paid membership has registered in advance.
            </li>
            <li>Expiring Subscription: Service that ends with expiration of service period.</li>
            <li>
              In-app Purchase: In-app purchased Beat(s) used to fulfill other transaction agreements, arrangements and
              conditions implemented by the Company and third parties.
            </li>
          </ol>
        </li>
        <li>
          When Member of paid membership has accessed the Service with cellular/wireless network or used all sorts of
          services with application on the device while connected to cellular/wireless network, separate cellular bill
          will be occurred under the cellular plan that has been in contract with registered cellular company. In such
          circumstances, occurred cellular bill will be charged/claimed/paid by the cellular plan of contract;
          therefore, the Company does not take any responsibilities related to the cellular bill.
        </li>
        <li>
          Use of contents may be restricted or modified due to the terms of contract with an individual, organization,
          corporation (“the rightful person, etc.”) that holds the right for the contents, whether the contract has been
          proceeded, or an afterward request from ‘the rightful person, etc.’. If a request has been received from ‘the
          rightful person, etc.’, the Company may alter the types of devices supported, the number of devices that a
          Member can use and more.
        </li>
      </ol>
      <b>Article 11. Paid Service Cost Modification</b>
      <br />
      The Company may modify or increase the cost of providing paid service, in-app purchase(s) for Beat(s) acquisition
      and the cost of other paid item(s) due to the necessity of management or technology and announcement to be made in
      advance to the Members by following Article 6 (Effect and Amendment of the Terms of Service).
      <br />
      <br />
      <b>Article 12. Paid Service Cancellation and Refund</b>
      <ol>
        <li>
          Member of paid service that has not used the paid service at all may terminate the contract within 7 days of
          payment date and payment cancellation or refund may be restricted under the conditions below.
          <ol>
            <li>
              In the case of already used all or portion of Service trial, coupon or Beat(s) (bonus included) received
              through payment.
            </li>
            <li>
              In the case of subscription purchased through payment that starts or applies to the Service right away.
            </li>
            <li>In the case of purchase processed due to Member’s negligence.</li>
          </ol>
        </li>
        <li>
          Even if the Member of paid service has not used the paid service at all, refund is invalid if contract
          termination is requested after a valid period (7 days within the payment date).
        </li>
        <li>
          If the Member has canceled or terminated already purchase service, paid service can still be used during the
          remaining contract period.
        </li>
        <li>Refund is processed through the Company or by each app store’s refund policy.</li>
        <li>
          The Member may request for a refund through electronic mail and the Company may request for additional
          evidence after verifying purchase history for refund payment.
        </li>
        <li>
          If the reason for contract termination or refund is in the Company’s faults such as, discontinue of Service,
          the charge occurred due to the refund is to be accounted by the Company. However, except for such cases, the
          Member will proceed and deduct the payment for any charge occurred from the benefit of using the paid service
          or fee required for refund.
        </li>
        <li>
          For paid service that the Member received as a gift or is using the paid service without paying due to
          receiving through promotion, the Company does not account the responsibility of refunding to the Member for
          paid service payment.
        </li>
        <li>
          If a minor has transacted without the consent of a legal representative, the minor or the legal representative
          may cancel the purchase. Other than the case where the minor has deceived to act as an adult or as if consent
          has been made by the legal representative, it cannot be canceled.
        </li>
        <li>
          In the case of monthly subscription by request or consent from Member of paid service, payment that the Member
          has made overdue may automatically be canceled from the day of arrears occurring, so if the Member desires to
          maintain the paid service, one must take action in advance to prevent payment arrears or payment method
          overdue.
        </li>
        <li>
          If the Member of paid service withdraws, the subscription cancels right away and refund is invalid. In this
          case, the Member’s information and use history of Mubeat service will be settled by following Mubeat’s Terms
          and this Terms of Service.
        </li>
        <li>
          There may be restrictions on the use of the Service if one repeatedly requests the same contract
          termination/refund of the same reason or type, or if one continues to request a contract termination/refund
          for unjust reasons.
        </li>
        <li>
          Once the contract termination/refund is completed, the withdrawal of the purchased item is processed, and the
          item used as Beat(s) becomes invalidated, and the item may become restricted or modified.
        </li>
      </ol>
      <br />
      <b>Article 13. Paid Service Suspension, Termination</b>
      <ol>
        <li>In principle, the Company provides paid service throughout the year 24 hours per day.</li>
        <li>
          The Company may restrict, suspend, terminate providing all or portion of service due to facility inspection
          and repairment with the purpose of service enhancement for users. In this case, the Company notifies the users
          in advance for the reason and duration of suspension in the method of Article 6 (Effect and Amendment of the
          Terms of Service) if possible and can notify right after for the reason and cause if it has been confirmed for
          the following cases.
          <ol>
            <li>
              In the case of difficulty in providing normal technical service due to a Member or other unspecified third
              party’s illegal, criminal act
            </li>
            <li>
              In the case of difficulty in providing normal paid service due to facility disorder, cellular or wireless
              network disorder or paid service’s high traffic
            </li>
            <li>
              In case of any situations happening beyond the control of the Company such as natural disaster, state of
              national emergency, power failure
            </li>
          </ol>
        </li>
        <li>
          The Company may gift a small benefit under Mubeat’s service management policy for the Member’s disadvantage
          from Service termination. However, Service termination due to natural disaster or any case beyond the control
          of the Company does not get included in the Service termination or malfunction period.
        </li>
        <li>
          The Company may modify, terminate, or alter partial or all services provided without charge for the Company’s
          imperative caused by the Company’s policy or management and unless there is a separate policy under its law,
          separate compensation does not count to be the responsibility of the Company.
        </li>
      </ol>
      <b>Article 14. The Company’s Responsibilities</b>
      <br />
      <ol>
        <li>
          The Company shall make efforts to provide the Service on the day the user has requested the usage of the
          Service.
        </li>
        <li>
          When the Company acknowledges that the opinions or complaints from the Member with respect to the use of the
          Service are justified, the Company shall handle them through proper procedures. As for the opinions or
          complaints from the Member, the Company shall inform the Member of the handling process and results.
        </li>
        <li>
          The Company shall make utmost efforts to provide convenience to the user during the process of the user’s
          agreement contract such as the contract of agreement of use and modification/termination of the contract
          details.
        </li>
        <li>The Company owns all rights to its Service.</li>
      </ol>
      <b>Article 15. Amendment and Interruption of Service</b>
      <ol>
        <li>
          The Company reserves the rights to change all or part of the Service pursuant to the operational and technical
          necessity.
        </li>
        <li>
          Should the changes materially affect the Member’s rights and obligations, the Company shall follow the rules
          stipulated in Article 6 before applying the changes to the Service.
        </li>
        <li>
          The Company may perform regular checkups if it is needed to provide the Service, which may lead to a temporary
          discontinuation of the Service.
        </li>
        <li>
          The Company may restrict or discontinue the Service if there is a state of national emergency,
          checkup/replacement/breakdown/interruption of communication facilities or significant operational reasons.
        </li>
        <li>The Company reserves the right to shut down the Service due to the Company’s management.</li>
      </ol>
      <b>Article 16. Member’s Rights and Duties</b>
      <ol>
        <li>
          The Member may watch the VOD and contents etc. (Hereinafter referred to collectively as “Content”) provided to
          the Member by the Service for personal and non-commercial purposes, and conduct the performances that the
          Company permits through the Service such as writing comments, postings, sharing and participating in the
          Service
        </li>
        <li>
          Besides the rights specified in the above, the Member receives no rights whatsoever on the Content provided by
          the Service
        </li>
        <li>
          The Member must not do any prohibited actions regarding the Content, including but not limited to the
          following actions, and shall abide by his/her rights and obligations detailed in these Terms of Service. A
          Member who acts outside the scope of permitted rights and obligations may be held responsible for both civil
          and penal legal consequences:
          <ol>
            <li>Arbitrarily create other video files with the Content.</li>
            <li>Arbitrarily upload the Content on the Internet.</li>
            <li>Arbitrarily share the Content with an unauthorized third party.</li>
            <li>
              All other acts that cause infringement of copyrights and intellectual property rights of the Content.
            </li>
          </ol>
        </li>
        <li>
          The Member shall not access the Service’s server network in an unauthorized manner. The Member also shall not
          perform any action that may disrupt the Service in any way.
        </li>
        <li>
          The Member is prohibited from taking any of the actions below:
          <ol>
            <li>Provide the Company with false information or plagiarize another person’s information.</li>
            <li>Violate the Company’s or a related third party’s copyright or intellectual property rights.</li>
            <li>Slander the Company’s or a related third party’s reputation.</li>
            <li>Commercially use the Service without the Company’s explicit consent.</li>
            <li>Falsely assume the Company or spread false information in regards to the Service.</li>
          </ol>
        </li>
        <li>
          The Member must agree not to appeal when the Company unilaterally suspends the use of the Service, forcibly
          terminates, or other suspensions of the Member under the case that the Member illegally uses the Service even
          after the Company prohibits or corrects the illegal use but the Member does not correct it.
        </li>
      </ol>
      <b>Article 17. Member’s Posting(s)</b>
      <br />
      The Company may delete the contents without prior notice, move or restrict the posting when the information
      created/uploaded by the Member in the Service such as the texts, documents, images, voices or combination of these
      (Hereinafter referred to as “Posting(s)”) is relevant to the following policy.
      <ol>
        <li>
          Posting that contains hateful, defamatory, or discriminatory contents against any individual or group,
          including the Company and any third parties such as posting publisher, and the artists of the contents.
        </li>
        <li>Posting that includes an offense against public order and morals.</li>
        <li>Posting that promotes fraudulent acts or violates any law.</li>
        <li>
          Posting that violates the Company and any third parties’ copyrights and all other rights protected by the
          relevant laws.
        </li>
        <li>Posting that exceeds the release period according to the Company’s internal policy.</li>
        <li>Posting that depicts sexually explicit contents or links to websites that contain such contents.</li>
        <li>
          Posting that goes against the internal policy regarding the Member’s Posting or is inappropriate to be on the
          Community.
        </li>
        <li>Posting that interrupts the operation of the Service.</li>
        <li>Posting that seeks to take advantage of the Service commercially without the consent of the Company.</li>
        <li>Unlawful contents prohibited to be posted in accordance with other relevant laws and regulations.</li>
      </ol>
      The Member is responsible for the use of the Service and for any contents he/she uploads and provides, including
      compliance with applicable laws, rules, and regulations. The Member should only provide contents that they are
      comfortable sharing with others.
      <br />
      Any use or reliance on any contents or materials posted on the Service or obtained by the Member through the
      Service is at their own risk. The Company does not endorse, support, represent or guarantee the completeness,
      truthfulness, accuracy, or reliability of any Postings or communications posted via the Service or endorse any
      opinions expressed via the Service. The Member should understand that by using the Service, they may be exposed to
      contents that might be offensive, harmful, inaccurate or otherwise inappropriate, or in some cases, Postings that
      have been mislabeled or are otherwise deceptive. All contents are the sole responsibility of the person who posted
      such contents.
      <br />
      In the case that the Member’s Posting is in breach of the Member’s obligations described in Article 17 (Member’s
      Postings) or includes contents prohibited to be posted in accordance with other relevant laws or regulations, the
      Company can take the following actions. The rights holder of such Postings can request suspension of the Posting
      release or elimination from the Service according to the procedures of the relevant laws, and the Company will
      take actions according to such relevant laws and regulations.
      <ol>
        <li>
          The Posting that received more than a certain number of reports, or when the violations have been confirmed,
          shall be automatically deleted. The Member who created this Posting may attempt to prove that it has not
          violated the prohibited behaviors stated in Article 17 (Member’s Postings), in order to remove the
          restriction.
        </li>
        <li>
          The Member who receives more than a certain number of reports, or whose violations have been confirmed, shall
          be restricted from creating further Postings. The concerned Member may attempt to prove that he/she has not
          violated the prohibited behaviors stated in Article 17 (Member’s Postings), in order to remove the
          restriction.
        </li>
        <li>
          The Member who receives more than a certain number of reports, or whose violations have been confirmed
          consistently, shall be restricted from using the Service for a maximum of 90 days to protect other Members and
          operation of the Service.
        </li>
        <li>
          The number of reports needed for deleting Postings or confirmation of violating article 17 (Member’s Postings)
          needed for restricting further Postings and use of the Service will be appropriately set from time to time in
          the course of Service operation. To make an appeal about this, the Member can use the Service’s relevant
          features or contact through support@mubeat.tv
        </li>
      </ol>
      <b>Article 18. Copyrights of Postings</b>
      <br />
      Copyrights of the Service and other intellectual property rights belong to the Company, and the Member who
      uploaded the Postings in the Service holds the copyrights of his/her Postings. But, when the Member directly
      uploads contents that includes the parts of the Service, the copyrights of the Postings belong to the Company.
      <br />
      The Company cannot use the Postings or contents included in the Postings uploaded by the Member in the Service
      with commercial purposes without the publisher’s consent. This excludes the case needed for the operation of the
      Service. But, when the Member directly uploads contents that includes parts of the Service, the Company can
      perform with commercial purposes by using such contents.
      <br />
      Limited use of rights given to the Postings created by the Member:
      <ol>
        <li>
          The Company, if needed, can use the Postings of the Members for the promotion of the Service. Also, the Member
          grants the Company the rights to translate, make technical revisions, share, reupload the Postings for the
          operation of the Service. This granted rights do not affect the ownership of the Postings.
        </li>
        <li>
          The Member cannot use the information obtained by using the Service or Content uploaded within the Service
          with commercial purposes.
        </li>
        <li>The Postings created by the Member may contain third parties’ websites or links to the Service.</li>
        <li>
          The Company does not control the third parties’ websites or links to the Service and is not responsible for
          anything caused by the Member’s use of such third parties’ websites or links to the Service.
        </li>
      </ol>
      <b>Article 19. Fandom Ad Service and Fandom Ad User Registered Contents Management</b>
      <ol>
        <li>
          The Member shall be responsible for the legal response and the result of any dispute with third parties, such
          as copyright or personal rights, related to the Member&apos;s fandom ad user registered contents provided to
          the fandom ad service. The Company expressly disclaims any liability with respect to such contents.
        </li>
        <li>
          The Company may expose the Member’s fandom ad user registered contents to search sites and other websites, and
          may use it for free in sales promotions, promotions and other materials. In addition, within the Service
          provided by the Company, Member’s posts can be reproduced, displayed, transmitted and distributed, and can be
          created as secondary works and editorial works. However, if the Member, who registered the fandom ad user
          registered contents, requests the deletion or suspension of his/her post, the Company will delete or suspend
          the use, except as required by the related laws.
        </li>
        <li>
          The Company does not allow copyright infringement or intellectual property infringement in the fandom ad
          service, and in the case that a Member’s fandom ad user registered contents is infringing or is perceived as
          infringing on the intellectual property rights of others, the fandom ad user registered contents service may
          be stopped or removed by following the procedures set forth in the copyright act and other related laws. In
          addition, the Company reserves the rights to delete, move or refuse registration without prior notice if the
          Company determines there is a problem with a Member&apos;s fandom ad user registered contents with the
          operation of the fandom ad service.
        </li>
        <li>
          By purchasing a product from the fandom ad service, which is a function of the Service, the Member is agreeing
          to the Terms of Service and the Company can collect the fandom ad user registered contents and use it for
          advertising or event purposes that pertains to the objectives of fandom ad service. <br />
          Photographs and graphic materials registered by users should use materials that do not infringe on the rights
          of third parties, such as copyrights, trademarks, and portrait rights (publicity rights). In the event where
          the registered image includes the following cases, at the administrator’s judgement and in accordance with the
          Terms of Service, the reflected image will be a basic image selected by the Company instead of the image
          uploaded by the user.
        </li>
        <li>
          Fandom ad user registered contents can be deleted without prior notice if it violates the conditions below.
          However, the Company is not obligated to inspect or censor posts.
          <ol>
            <li>In the case of defamation or slander of another Member or third party.</li>
            <li>In the case of violation of public order and morals.</li>
            <li>If the contents is deemed to be related to criminal activity.</li>
            <li>
              In the case where the contents infringe the copyright of the Company, the copyright of third parties, or
              the infringement of other rights.
            </li>
            <li>
              When a Member posts pornographic material on the Company&apos;s homepage and bulletin board or links to
              sexually explicit websites.
            </li>
            <li>
              In the case where the contents is judged to be an advertisement article or similar to an advertisement
              article.
            </li>
            <li>When it is judged to be in violation of other related laws.</li>
            <li>If it does not meet the objectives of the fandom ad service.</li>
          </ol>
        </li>
        <li>
          As provided in these Terms, the Company or the person designated by the Company shall be granted the rights to
          use the fandom ad user registered contents. The purpose and method for the Company to use the Member’s fandom
          ad user registered contents is as follows.
          <ol>
            <li>
              Member who purchased the fandom ad service product can use fandom ad user registered contents provided by
              the fandom ad service to create fandom ad image.
            </li>
            <li>
              The fandom ad image completed with the fandom advertisement user registered contents provided by the
              fandom ad service can be released to be viewed by an unspecified number of users.
            </li>
          </ol>
        </li>
      </ol>
      <b>Article 20. Advertisements and Transactions with Advertisers</b>
      <ol>
        <li>
          The Company can distribute ads in the form of banner ads, post ads, video ads, etc in the areas run by the
          Service (including mobile and web page) which the Company operates and manages, in mails sent to Members, and
          in other services.
        </li>
        <li>
          In accordance with Clause 1, the Member is responsible for any participation or transaction with the
          aforementioned advertiser&apos;s promotional activity, and the Company is not liable for any loss or damage of
          either party that occurs during the process of transaction or negotiation between the advertiser and the
          Member.
        </li>
      </ol>
      <b>Article 21. Use Restrictions</b>
      <br />
      The Company may restrict the Member’s use of the Service temporarily or permanently under the conditions below.
      <ol>
        <li>Violating the obligations of Article 16 (Member’s Rights and Duties).</li>
        <li>Falsely registering his/her personal information.</li>
        <li>
          Using the Service for commercial purposes or interrupting the Service usage of another person/party other than
          yourself.
        </li>
        <li>Assigning, renting, or trading your ID and password to another person/party other than yourself.</li>
        <li>
          Modifying Service client program, hacking the Server, and modifying any or all parts of the application
          without permission.
        </li>
        <li>Deliberately interrupting the Company’s operation of the Service.</li>
        <li>Posting information online which can possibly violate the Company or the copyright holder’s copyrights.</li>
        <li>
          Using the unique information about this Service obtained as the Member for commercial use without the consent
          of the Company.
        </li>
        <li>
          When it is determined that Article 17 (Member’s Postings) has been violated and user restriction is necessary.
        </li>
      </ol>
      <b>Article 22. Ending These Terms</b>
      <br />
      The Member may end his/her legal agreement with the Company at any time by closing their account and discontinuing
      the use of the Service. The Member can withdraw the use of Service through the Mubeat APP &gt; My Page &gt;
      Settings &gt; FAQ &gt; CLOSE MY ACCOUNT or make a request by contactacting support@mubeat.tv.
      <br />
      The Company uses the information provided by the Member after he/she withdraws from the Service in the following
      cases.
      <br />
      Please be aware that closing the account could cause elimination of all contents related to the Member’s account.
      When the Member withdraws from the Service, the Company may or may not check the Postings saved in the Member’s
      account within the limits of relevant laws and this Terms of Service. If the saved Postings are checked, the
      Member can request discontinuation of Posting checks or elimination of Postings through support@mubeat.tv.
      <br />
      In the case of the Member terminating the contract, he/she should use up all remaining Beat(s) and others, and
      remaining purchase history of Beat(s) and others before applying.
      <br />
      The Company shall not be held responsible for the restoration of any remaining balance and purchase history in the
      case of voluntary withdrawal after the Company has informed that the restoration of the service usage information
      that includes the remaining balance and purchase history is impossible after closing the account.
      <br />
      The Articles that need to be maintained in essence will continue to be in effect after the termination of this
      Terms of Service. Such are stated in the following cases.
      <ol>
        <li>The liability of the Member to pay the fees owed to the Company.</li>
        <li>Condition of Company’s limitation of responsibility, ownership or intellectual property rights.</li>
        <li>Conditions about the disputes between the Company and the Member.</li>
      </ol>
      <b>Article 23. Compensation</b>
      <br />
      In cases where the Company or the Member has caused loss/damage to the other party due to the attributable reasons
      respectively, the Company or the Member is responsible and liable to compensate. In particular, if the Member
      infringes the contents copyright by violating Article 16 Clause 3, the Member is fully responsible and liable to
      any civil and criminal liabilities.
      <br />
      The Company shall not be responsible for the goods or service provided by the affiliates.
      <br />
      <br />
      <b>Article 24. Limitation of Liability</b>
      <br />
      The Company shall be exempt from any responsibility related to providing the Service in the case where the Company
      is unable to provide the Service due to natural disasters, wars or any force measure.
      <br />
      The Company shall be exempt from any responsibility when there was a loss caused to a Member by using the Content
      unless there are attributable reasons intentionally or negligently by the Company.
      <br />
      The Company shall not be responsible regarding the free service unless there is a special provision in the
      relevant laws.
      <br />
      <br />
      <b>Article 25. Governing Law and Jurisdiction</b>
      <br />
      Disputes that arise between the Company and the Member shall be governed by the laws of the Republic of Korea.
      <br />
      Lawsuits surrounding disputes that arise between the Company and the Member shall be brought to the jurisdiction
      of the Member&apos;s address at the time the lawsuit is filed. If no address is available, the lawsuit shall be
      brought to the district court that has jurisdiction over the Member&apos;s place of residence. However, if the
      Member&apos;s address of place of residence is unknown at the time of the lawsuit, the lawsuit shall be brought to
      the competent court stated in the Civil Procedure Act. Seoul Central District Court of the Republic of Korea. All
      disputes that arise between the Company and the Member with an overseas address or place of residence shall be
      brought exclusively to the Seoul Central District Court of the Republic of Korea, despite the previous sentence.
      <br />
      <br />
      Addendum.
      <br />
      The following Terms of Service will take effect from Sep 30th, 2021.
    </>
  );
};

export default TermsOfServiceEN;
